/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Otp method
 */
export type ObtainOtpRequestMethod = typeof ObtainOtpRequestMethod[keyof typeof ObtainOtpRequestMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ObtainOtpRequestMethod = {
  AUTHENTICATOR: 'AUTHENTICATOR',
  EMAIL: 'EMAIL',
  SMS: 'SMS',
} as const;
